import { render, staticRenderFns } from "./DepotCustomerDashboard.vue?vue&type=template&id=0f413f8d&scoped=true&"
import script from "./DepotCustomerDashboard.vue?vue&type=script&lang=ts&"
export * from "./DepotCustomerDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./DepotCustomerDashboard.vue?vue&type=style&index=0&id=0f413f8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f413f8d",
  null
  
)

export default component.exports